import { FloatingIsland } from '../FloatingIsland';
import { DisplayMode } from '@rocco/types/enum/display-mode';

import {
    DetailsPageIslandImage,
    type DetailsPageIslandImageProps,
} from './DetailsPageIslandImage';

interface DetailsPageIslandProps {
    image?: DetailsPageIslandImageProps;
    title: string;
    description: string | React.ReactNode;
    primaryAction: React.ReactNode;
    secondaryAction: React.ReactNode;
    displayMode: DisplayMode;
    scrollThreshold?: number;
    isClickable?: boolean;
    onClick?: () => void;
}

export const DetailsPageIsland = ({
    image,
    title,
    description,
    primaryAction,
    secondaryAction,
    displayMode,
    scrollThreshold = 100,
    isClickable = true,
    onClick,
}: DetailsPageIslandProps) => {
    const showImage = image && displayMode === DisplayMode.Desktop;
    const variant = showImage ? 'details' : 'detailsNoImage';

    return (
        <FloatingIsland scrollThreshold={scrollThreshold} variant={variant}>
            <div className="flex gap-2.5 md:gap-6 items-center md:min-h-18">
                <div className="hover:cursor-pointer" onClick={onClick}>
                    {showImage ? <DetailsPageIslandImage {...image} /> : null}
                </div>

                <div className="flex flex-col gap-1 md:gap-2 min-w-0 flex-1 items-start w-fit">
                    <a
                        className={`w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium md:text-base md:leading-[1.25] ${
                            isClickable
                                ? 'cursor-pointer hover:text-primary-600'
                                : 'cursor-default'
                        }`}
                        onClick={isClickable ? onClick : undefined}
                    >
                        {title}
                    </a>
                    {typeof description === 'string' ? (
                        <p className="text-3 md:text-sm tracking-[0.0175rem] text-gray-500 text-ellipsis overflow-hidden cursor-default">
                            {description}
                        </p>
                    ) : (
                        description
                    )}
                </div>
                <div className="flex gap-2.5 shrink-0">
                    {secondaryAction}
                    {primaryAction}
                </div>
            </div>
        </FloatingIsland>
    );
};
